import React, { Component } from 'react';
import { shuffleArray } from '../../lib/ep.js';
import { isEqual as _isEqual, size as _size, shuffle as _shuffle } from 'lodash';
import { Stage, Layer, Rect } from 'react-konva';

import ActionButton from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import Spinner from '../builder/Spinner';

const Legend = (props) => {
	const words = (props.words != undefined) ? props.words : [];

	return (
		<ButtonCollection _class={{other:'gui_not_in_top gui_flex_center'}}>
			<p>{props.process}</p>
			{words.map((word, i) => {
				return (
					<ActionButton
						key={i}
						color="black"
						onClick={() => props.onCheckWord(word)}
						autotranslate={false}
					>{word}</ActionButton>
				)
			})}
		</ButtonCollection>
	)
}

class RevealCanvas extends Component {
	constructor(props, context) {
		super(props, context);

		this.foo_columns = [];
		this.state = {
			background_image:props.image,
			background_image_obj:null,
			columns:this.setLevel(props),
			enable_reveal_more:true,
			fillPatternImage:null,
			full_loaded:false,
			image:props.image,
			image_w:100,
			image_h:100,
			items:[],
			max_percent_visible:50,
			percent_visible:100,
			positions_items:[],
			size_piece_h:0,
			size_piece_w:0,
			clicked_elements:{},
			index_playing_item:0,
			reveals:[],
			level:(props.level != undefined) ? props.level : 'easy',
			words:(props.words != undefined) ? props.words : [],
			num_plays:(props.num_plays != undefined) ? props.num_plays : 1,
			show_all:false,
		};

		this.size = 600;
		this.words_to_play = 4;

		this.ok_color = props.color_ok;
		this.ko_color = props.color_ko;
		this.transparent_color = 'rgba(0, 0, 0, 0)';

		this.positions_items = [];
		this.loaded_images = [];
		this.background_image;

		this.move_in_sound = props.sound_fx.move_in;
		this.move_out_sound = props.sound_fx.move_out;
		if(props.stageInstance != undefined) props.stageInstance(this);
	}

	/*START SOUNDS*/
	startMovePlay() {
		this.move_in_sound.play();
	}

	endMovePlay() {
		this.move_out_sound.play();
	}
	/*END SOUNDS*/

	componentWillMount() {
		this.setLevel(this.props);
		this.calcImageSizes();
	}

	componentDidMount() {
		const t = setTimeout(() => {
			this.gameInit();
			this.loadBackgroundImage();
		}, ((!this.is_builder) ? 4500 : 100));


		window.onresize = () => {
			this.gameInit(true);
		}
	}

	componentWillReceiveProps(props) {
		if(props.level != this.props.level || props.image != this.props.image || props.num_plays != this.props.num_plays || !_isEqual(props.words, this.props.words)) {
			//if(props.image != this.props.image) this.state.background_image = props.image;
			if(props.num_plays != this.props.num_plays) this.state.num_plays = props.num_plays;
			if(props.words != this.props.words) this.state.words = props.words;
			if(props.level != this.props.level) this.state.level = props.level;

			if(!_isEqual(props.image, this.props.image)) {
				this.state.background_image = props.image;
				this.loadBackgroundImage();
			}

			this.setState({...this.state});
			this.calcImageSizes();
			this.gameInit();
		}

		if(props.to_reset != this.props.to_reset) this.resetGame();
	}

	loadBackgroundImage() {
		if(!this.state.background_image) return false;

		const image = this.state.background_image;
		this.background_image  = new window.Image();
		this.background_image.crossOrigin = 'Anonymous';
		this.background_image.src = this.state.background_image;
		this.background_image.onload = () => {
			var img = this.background_image;
			this.state.background_image_obj = {
				fillPatternImage:img,
				image_w:img.width,
				image_h:img.height,
				size_piece_w:img.width / this.state.columns,
				size_piece_h:img.height / this.state.columns,
			}
			this.setState({...this.state});
		}
	}

	handleLoad(image, index) {
		var image = this.loaded_images[index];

		const new_image = {
			fillPatternImage:image,
			image_w:image.width,
			image_h:image.height,
			rotation:0,
			size_piece_w:image.width,
			size_piece_h:image.height,
			word:image.word,
			option_words:[],
			empty:false,
		};

		this.state.reveals.push(new_image);
		if((this.state.loaded + 1) == _size(this.state.images)) {
			this.shuffle();
		} else {
			this.state.loaded = this.state.loaded + 1;
			this.setState({...this.state});
		}
	}

	calcImageSizes() {
		const images = this.props.images;
		const names = this.props.names;

		//for(var i = 0; i < num_columns - 1; i++) this.foo_columns.push("foo");
		images.map((source, index) => {
			this.loaded_images[index] = new window.Image();
			this.loaded_images[index].crossOrigin = 'Anonymous';
			this.loaded_images[index].src = source;
			this.loaded_images[index].word = names[index];
			this.loaded_images[index].onload = () => {
				this.setState({
					fillPatternImage:this.loaded_images[index],
					image_w:this.loaded_images[index].width,
					image_h:this.loaded_images[index].height,
					size_piece_w:this.loaded_images[index].width / this.state.columns,
					size_piece_h:this.loaded_images[index].height / this.state.columns,
				});

				this.handleLoad(this.loaded_images[index], index);
			}
		});
	}

	resetGame() {
		this.state.clicked_elements = {};
		this.state.index_playing_item = 0;
		//this.state.reveals = [];
		this.state.full_loaded = false;
		this.state.enable_reveal_more = true;
		this.state.percent_visible = 100;

		this.setState({...this.state});
		this.gameInit();
	}

	gameInit(from_resize) {
		if(from_resize == undefined) from_resize = false;

		if(this.props.adaptToContainer != undefined) this.props.adaptToContainer((size) => {
			this.size = size;

			if(!from_resize) {
				this.calcSquares();
				this.shuffle();
			}

			this.setState({ full_loaded:true });
		});
	}

	calcSquares() {
		this.state.items = [];

		const number_of_items = this.state.columns * this.state.columns;
		for(var i = 0; i < number_of_items; i++) {
			const x = (i % this.state.columns * 100) / this.state.columns;
			const y = (Math.floor(i / this.state.columns) * 100) / this.state.columns;
			this.state.items.push({
				position:i,
			});
		}

		const size_part = this.size / this.state.columns;

		for(var pos = 0; pos < number_of_items; pos++) {
			const ini_pos_x = Math.floor(pos % this.state.columns) * size_part;
			const ini_pos_y = Math.floor(pos / this.state.columns) * size_part;
			this.positions_items.push({
				x:ini_pos_x,
				y:ini_pos_y,
			});
		}
	}

	setLevel(props) {
		var columns;
		switch(props.level) {
			case 'hard':
				columns = 14;
				break;
			case 'normal':
				columns = 10;
				break;
			case 'easy':
			default:
				columns = 6;
				break;
		}

		this.foo_columns = [];
		for(var i = 0; i < columns - 1; i++) this.foo_columns.push("foo");

		return columns;
	}

	shuffle(cb) {
		var items = this.state.reveals;
		if(_size(items) > 0) {
			var currentIndex = items.length, temporaryValue, randomIndex;

			// While there remain elements to shuffle...
			while(currentIndex !== 0) {
				// Pick a remaining element...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;

				// And swap it with the current element.
				temporaryValue = items[currentIndex];
				items[currentIndex] = items[randomIndex];
				items[randomIndex] = temporaryValue;
			}

			items.sort();
			items.map((item, i) => {
				items[i].option_words = this.getWordsByItem(item.word);
			});

			items = items.splice(0, this.props.num_plays);
			this.state.reveals = items;
			this.setState({ ...this.state });
		}
	}

	getWordsByItem(word_default) {
		const words = (this.state.words != undefined) ? this.state.words : [];

		var all_words = [];
		words.map((item, i) => {
			all_words.push(item);
		});

		this.state.reveals.map((item, i) => {
			if(item.word!=word_default){
				all_words.push(item.word);
			}
		});

		var extra_words = shuffleArray(all_words).splice(0, this.words_to_play - 1);
		extra_words.push(word_default);

		const shuffled_words = _shuffle(extra_words);

		return shuffled_words;
	}

	clickWord(word) {
		var new_reveal = false;
		var is_solved = false;

		if(this.state.reveals[this.state.index_playing_item].word == word && _size(this.state.clicked_elements) > 0) {
			this.showAll(() => {
				const t = setTimeout(() => {
					this.state.index_playing_item = this.state.index_playing_item + 1;
					this.state.clicked_elements = {};
					this.state.show_all = false;
					this.state.percent_visible = 100;
					this.state.enable_reveal_more = true;

					//TOMA PREMIO
					this.setState({...this.state});
					if(this.props.onHitResult != undefined) this.props.onHitResult();
					is_solved = this.isSolved();
				}, 1500);
			})
		}

		if(this.props.onFireAttempt != undefined) this.props.onFireAttempt({error:!is_solved}, is_solved);
	}

	showAll(cb) {
		this.setState({ show_all:true });
		if(cb != undefined) cb();
	}

	isSolved() {
		var is_solved = (_size(this.state.reveals) == this.state.index_playing_item) ? true : false
		if(is_solved) {
			if(this.props.onSolve != undefined) this.props.onSolve(is_solved);
		}

		return is_solved;
	}

	handleClick(e, index) {
		if(!this.state.enable_reveal_more) return false;

		const rec = this.refs['part_' + index];
		if(rec.attrs.fill != this.transparent_color) {
			this.state.clicked_elements[index] = true;
			this.getPercentVisible();
		}
		this.setState({...this.state});
	}

	getPercentVisible() {
		const total_pieces = this.state.columns * this.state.columns;
		const visible_pieces = _size(this.state.clicked_elements);

		const percent = 100 * visible_pieces / total_pieces;
		this.state.enable_reveal_more = (percent >= this.state.max_percent_visible) ? false : true;
		this.state.percent_visible = Math.max(100 - (100 / this.state.max_percent_visible) * percent, 0);
	}

	render() {
		const theme = (this.props.theme != undefined) ? this.props.theme : 'light';
		const this_reveal = (this.state.reveals[this.state.index_playing_item] != undefined) ? this.state.reveals[this.state.index_playing_item] : false;
		const size_portion = this.size / this.state.columns;
		const background_image = (this.state.background_image && this.state.background_image_obj != undefined) ? this.state.background_image_obj : false;
		const slide_size_background = (background_image) ? this.size / (Math.max(background_image.image_w, background_image.image_h)) : false;

		if(_size(this.state.reveals) == 0) {
			return (
				<div>NO Image</div>
			)
		}

		if(_size(this_reveal.option_words) < this.words_to_play) {
			return (
				<div>You need at least 4 words/images</div>
			)
		}

		return (
			<aside class="game_container is_reveal">
				<div class="gui_progress gui_not_in_bottom_small">
					<div class="bar_guide" style={{background:'rgb(' + this.ko_color + ', 1)'}}>
						<div class="bar gui_is_animated" style={{background:'rgb(' + this.ok_color + ', 1)', width:(Math.round(100 * this.state.percent_visible) / 100)+'%'}}></div>
					</div>
				</div>

				<div class={'canvas_content is_' + theme}>
					<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />

					{(this.state.full_loaded) ? (
						<Stage className={'canvas_cont' + ((!this.state.full_loaded) ? ' not_loaded_yet' : '')} width={this.size} height={this.size} ref="stage">
							<Layer ref="layer">
								<Rect
									key='item-reveal-bg'
									x={0}
									y={0}
									fill={'rgba(' + this.ko_color + ', 1)'}
									opacity={(this.state.enable_reveal_more) ? 0 : 0.5}
									width={this.size}
									height={this.size}
								/>

								{(background_image) && (
									<Rect
										key='item-reveal'
										x={0}
										y={0}
										fill={(background_image) ? null : ((theme == 'light') ? 'white' : 'black')}
										width={this.size}
										height={this.size}
										fillPatternImage={background_image.fillPatternImage}
										fillPatternRepeat='no-repeat'
										fillPatternScaleX={slide_size_background}
										fillPatternScaleY={slide_size_background}
										fillPatternOffsetX={slide_size_background / 2}
										fillPatternOffsetY={slide_size_background / 2}
									/>
								)}

								{this.state.items.map((value, index) => {
									const x_ini = Math.floor(index % this.state.columns) * size_portion;
									const y_ini = Math.floor(index / this.state.columns) * size_portion;

									const offset_x = Math.floor(value.position % this.state.columns) * this.state.size_piece_w;
									const offset_y = Math.floor(value.position / this.state.columns) * this.state.size_piece_h;
									const positive_index = index + 1;
									const show = (this.state.clicked_elements[positive_index] != undefined && this.state.clicked_elements[positive_index]) ? true : false;

									return (
										<Rect
											ref={'part_' + positive_index}
											key={index}
											x={x_ini}
											y={y_ini}
											width={size_portion}
											height={size_portion}
											fill={null}
											fillPatternImage={(show || this.state.show_all) ? this_reveal.fillPatternImage : null}
											fillPatternRepeat="no-repeat"
											fillPatternScaleX={this.size / this.state.image_w}
											fillPatternScaleY={this.size / this.state.image_h}
											fillPatternOffset={{x:offset_x, y:offset_y}}
											opacity={(!show && this.state.show_all) ? 0.8 : 1}
											onClick={(!show && !this.state.show_all) ? (e) => this.handleClick(e, positive_index) : null}
											onTap={(!show && !this.state.show_all) ? (e) => this.handleClick(e, positive_index) : null}
											onMouseEnter={() => { document.body.style.cursor = ((this.state.enable_reveal_more && !show && !this.state.show_all) ? 'pointer' : 'default'); }}
											onMouseLeave={() => { document.body.style.cursor = 'default'; }}
										/>
									)
								})}

								{this.foo_columns.map((foo, i) => {
									const x_ini = (i + 1) * size_portion;

									return (
										<Rect
											key={'line_v-' + i}
											x={x_ini}
											y={0}
											stroke='rgba(0, 0, 0, 0.2)'
											strokeWidth={1}
											width={0}
											height={this.size}
										/>
									)
								})}

								{this.foo_columns.map((foo, i) => {
									const y_ini = (i + 1) * size_portion;

									return (
										<Rect
											key={'line_h-' + i}
											x={0}
											y={y_ini}
											stroke='rgba(0, 0, 0, 0.2)'
											strokeWidth={1}
											width={this.size}
											height={0}
										/>
									)
								})}
							</Layer>
						</Stage>
					) : (
						<div class="gui_not_in_top gui_flex_center">
							<Spinner>Loading game</Spinner>
						</div>
					)}
				</div>

				<Legend words={this_reveal.option_words} process={(this.state.index_playing_item + 1)+'/'+this.state.num_plays} onCheckWord={this.clickWord.bind(this)} />
			</aside>
		);
	}
}

export default RevealCanvas;